import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

import { isAdminRole } from "@/auth/shared";
import { ProfilesList } from "@/components/admin/profiles-list";
import { DefaultLayout } from "@/layouts/default";

const profilesSearchSchema = z.object({
  name: z.string().default(""),
  email: z.string().default(""),
  phone: z.string().default(""),
});

export const Route = createFileRoute("/admin/profiles")({
  validateSearch: zodValidator(profilesSearchSchema),
  loader: async ({ context }) => {
    const viewer = context.viewer;

    if (!viewer || !isAdminRole(viewer.role)) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { name, email, phone } = Route.useSearch();

  return (
    <DefaultLayout
      classNames={{
        content:
          "flex flex-col space-y-12 max-w-full xl:max-w-2xl px-3 py-12 mx-auto",
      }}
    >
      <ProfilesList
        initialName={name}
        initialEmail={email}
        initialPhone={phone}
      />
    </DefaultLayout>
  );
}
